import axios from 'axios';
import BaseAPI from './base/base-api';

class NotificationUserAPI extends BaseAPI {
    constructor() {
        super();
    }
    urlName = 'InvoiceBotsAPI';
    controllerName = 'notificationuser';
}

export default new NotificationUserAPI();